export const homeStatic = {
  main_scroll: {
    title_ua: 'Забронювати пробний урок',
    title_ru: 'Забронировать пробный урок',
  },
};
